import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'next-themes'
import { MotionConfig } from 'framer-motion'
import App from '@/App.jsx'
import '@/index.css'

// Après une mise en ligne, un onglet resté ouvert demande les morceaux de l'ancienne version, qui
// n'existent plus : on recharge une fois pour prendre la nouvelle (30/10/2026, écran blanc d'Ismaël).
const RECHARGE = 'recharge-apres-mise-a-jour';
window.addEventListener('vite:preloadError', (e) => {
  try {
    if (sessionStorage.getItem(RECHARGE)) return;
    sessionStorage.setItem(RECHARGE, '1');
  } catch { /* stockage indisponible : on recharge quand même une fois */ }
  e.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => { setTimeout(() => { try { sessionStorage.removeItem(RECHARGE); } catch { /* rien */ } }, 10_000); });

/** Plus jamais d'écran blanc : une erreur d'affichage montre un message et un bouton pour recharger. */
class FiletErreur extends React.Component {
  constructor(props) { super(props); this.state = { erreur: null }; }

  static getDerivedStateFromError(erreur) { return { erreur }; }

  componentDidCatch(erreur, info) { console.error('[dashboard] erreur d’affichage', erreur, info?.componentStack); }

  render() {
    if (!this.state.erreur) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#F4F5F7', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ maxWidth: 460, background: '#fff', borderRadius: 16, padding: 24, border: '1px solid #E5E7EB' }}>
          <h1 style={{ fontSize: 20, margin: '0 0 8px' }}>Le dashboard n’a pas pu s’afficher</h1>
          <p style={{ fontSize: 14, color: '#4B5563', margin: '0 0 16px' }}>Rechargez la page. Si le problème revient, envoyez une capture de ce message à Jim.</p>
          <button type="button" onClick={() => window.location.reload()} style={{ minHeight: 44, padding: '0 18px', borderRadius: 10, border: 0, background: '#2F5BFF', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Recharger</button>
          <p style={{ fontSize: 12, color: '#9CA3AF', margin: '16px 0 0', wordBreak: 'break-word' }}>{String(this.state.erreur?.message || this.state.erreur)}</p>
        </div>
      </div>
    );
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <FiletErreur>
    <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false} disableTransitionOnChange>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </ThemeProvider>
  </FiletErreur>
)
